<template>
  <div class="accumulator__container">
    <div class="accumulator__container__headline">
      <h1 class="h1--underline">
        {{ $tv('accumulatorSelectorTitle', 'accumulatorSelector') }}
      </h1>
    </div>
    <div class="accumulator-selector__content">
      <accumulator-selector />
    </div>
    <div class="accus-disclaimer-message">
      <span v-tv:accumulatorSelector="'disclaimerMessageScreenSize'" />
    </div>
    <PopupAccuDisclaimer
      :show="showDisclaimer"
      :class="showDisclaimer ? 'popup--visible' : ''"
    />
  </div>
</template>

<script setup lang="ts">
import useBreadcrumb from '~/composables/useBreadcrumb'
import useI18nExtended from '~/composables/usei18nExtended'
import PopupAccuDisclaimer from '~/components/popup/PopupAccuDisclaimer.vue'
import {useConfigurationDataStore} from '@/store/configuration-data'
import createSeoMetaInfo from '~/assets/js/opengraph/helper.ts'

const i18n = useI18nExtended()
const BASE_URL = useRuntimeConfig().public.BASE_URL
const region = useNuxtApp().$globalization.getRegion()

const seoInfo = createSeoMetaInfo({
  title: i18n.tv('ogTitle', 'accumulatorSelector'),
  description: i18n.tv('ogDescription', 'accumulatorSelector'),
  image: BASE_URL + '/img/accus-og.png',
  url: `${BASE_URL}/${region.toLowerCase()}/${i18n.locale.value}/accumulator-selector`,
  locale: i18n.locale.value
})

useSeoMeta(seoInfo)

useBreadcrumb([
  {
    label: i18n.tv('accumulatorSelector', 'breadcrumbs'),
    path: '/accumulator-selector'
  }
])

const showDisclaimer = computed(() => {
  return !useConfigurationDataStore().acceptedAccumulatorSelectorDisclaimer
})

</script>
<style lang="scss">
.accumulator__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  &__headline {
    padding: .5rem 1.625rem 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: .625rem;
    align-self: stretch;
    background-color: $color__content--background__primary;

    h1 {
      font-weight: $base-text-font-weight-semi-bold;
      line-height: 1.95rem;
      margin: 0;
    }
  }

  .accumulator-selector__content {
    display: flex;
    align-self: stretch;
    justify-content: space-around;
    margin-top: 2rem;
    background-color: $color__content--background__primary;
    padding: 1.25rem 1.625rem 0;
    overflow: hidden;
  }
}
</style>
